import { Link } from "react-router";
import { Logo } from "@/components/logo";
import { SagePeriod } from "@/components/sage-period";

const FOOTER_LINKS = [
  { href: "/about", label: "About" },
  { href: "/privacy", label: "Privacy" },
  { href: "/terms", label: "Terms" },
] as const;

const BUILD_YEAR = new Date().getFullYear();

export function Footer() {
  return (
    <footer className="bg-footer text-sidebar-muted">
      <div className="mx-auto flex max-w-5xl flex-col items-start gap-6 px-6 py-12 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <Logo variant="inverse" />
          <p className="mt-1 text-sm">
            Privacy, <span className="whitespace-nowrap">engineered<SagePeriod className="bg-on-ink-accent" /></span>
          </p>
        </div>
        <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-6 gap-y-2">
          {FOOTER_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="inline-flex min-h-11 min-w-11 items-center text-sm transition-colors hover:text-sidebar-foreground"
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://www.linkedin.com/company/truspecta/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Truspecta on LinkedIn (opens in a new tab)"
            className="inline-flex min-h-11 min-w-11 items-center justify-center text-sm transition-colors hover:text-sidebar-foreground"
          >
            <svg aria-hidden="true" className="size-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>
        </nav>
      </div>
      <div className="mx-auto max-w-5xl border-t border-sidebar-border px-6 py-6">
        <span className="text-xs">
          Truspecta &copy; {BUILD_YEAR}
        </span>
      </div>
    </footer>
  );
}
